export const types = {
  CONTACT_ADMIN: '@PROFILE/CONTACT_ADMIN',
  UPDATE_PERSONAL_DATA: '@PROFILE/UPDATE_PERSONAL_DATA',
  FETCH_PROFILE: '@PROFILE/FETCH_PROFILE',
  FILL_PROFILE: '@PROFILE/FILL_PROFILE',
  CHANGE_PASSWORD: '@PROFILE/CHANGE_PASSWORD',
  TERMS_AGREE: '@PROFILE/TERMS_AGREE',
  CLEAR: '@PROFILE/CLEAR'
};
